/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Recovery_DescriptionInputs */

const en_two_fa_recovery_description = /** @type {(inputs: Two_Fa_Recovery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use these codes to sign in if you lose access to your authenticator app. Each code works once. These codes will only be shown now. Save them in a safe place before continuing.`)
};

const nl_two_fa_recovery_description = /** @type {(inputs: Two_Fa_Recovery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik deze codes om in te loggen als je geen toegang meer hebt tot je authenticator-app. Elke code werkt één keer. Deze codes worden alleen nu getoond. Bewaar ze op een veilige plek voordat je doorgaat.`)
};

/**
* | output |
* | --- |
* | "Use these codes to sign in if you lose access to your authenticator app. Each code works once. These codes will only be shown now. Save them in a safe place ..." |
*
* @param {Two_Fa_Recovery_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_recovery_description = /** @type {((inputs?: Two_Fa_Recovery_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Recovery_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_recovery_description(inputs)
	return en_two_fa_recovery_description(inputs)
});